var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchTemplate',{scopedSlots:_vm._u([{key:"search-body",fn:function(){return [(_vm.success)?[_c('SearchResult')]:[_c('SearchError',{attrs:{"message":_vm.message}})]]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }